import { render } from "./TemplateFileManagement.vue?vue&type=template&id=1c7b84b5"
import script from "./TemplateFileManagement.vue?vue&type=script&lang=js"
export * from "./TemplateFileManagement.vue?vue&type=script&lang=js"

import exportComponent from "D:\\newProjectGit\\HbzsbAdminClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__